export const PRO_MONTHLY_PRICE_USD = 5;
export const PRO_YEARLY_PRICE_USD = 50;

// Lifetime Pro: one-time payment, Pro for the lifetime of the service, with a
// single credit grant and no monthly refill (credits packs still available).
export const PRO_LIFETIME_PRICE_USD = 99;
export const LIFETIME_CREDITS = 50000;
// Stored as a far-future stripe_current_period_end; credits_reset_bounds
// gives up past 24 months and reset_at stays null, so nothing ever refills.
export const LIFETIME_PERIOD_YEARS = 100;

export const PRO_YEARLY_SAVINGS_PERCENT = Math.round(
  (1 - PRO_YEARLY_PRICE_USD / (PRO_MONTHLY_PRICE_USD * 12)) * 100
);
